/**
 * PostHog Analytics Events for Documents Tab Features
 * Tracks: Document pinning/unpinning, document preview interactions
 */

// Event names
export const DOCUMENTS_EVENTS = {
  // Pin events
  DOCUMENT_PINNED: 'document_pinned',
  DOCUMENT_UNPINNED: 'document_unpinned',

  // Preview events
  DOCUMENT_PREVIEW_OPENED: 'document_preview_opened',
  DOCUMENT_PREVIEW_FULLSCREEN: 'document_preview_fullscreen',

  // Dock interactions
  PINNED_DOCK_TAB_CLICKED: 'pinned_dock_tab_clicked',
  PINNED_DOCK_TAB_CLOSED: 'pinned_dock_tab_closed',
} as const;

// Property names
export const DOCUMENTS_PROPERTIES = {
  // Common
  MATTER_ID: 'matter_id',
  PAGE: 'page',
  COMPONENT: 'component',

  // Document properties
  DOCUMENT_ID: 'document_id',
  FILE_NAME: 'file_name',
  FILE_TYPE: 'file_type',
  FILE_SIZE: 'file_size',

  // Pin properties
  PINNED_COUNT: 'pinned_count', // total pinned after action
  UNPIN_SOURCE: 'unpin_source', // 'preview_button' | 'dock_tab_close'
} as const;

// Type helpers
export type DocumentsEvent =
  (typeof DOCUMENTS_EVENTS)[keyof typeof DOCUMENTS_EVENTS];
export type DocumentsProperty =
  (typeof DOCUMENTS_PROPERTIES)[keyof typeof DOCUMENTS_PROPERTIES];
